import React, { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { Box, Grid } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { EXERCISE_RESERVATION } from "../../../Routing/routes";
import qs from "qs";

const styleDiv = { marginBottom: 100, width: "100%", marginTop: 100 };

const FinalizeSuccess: React.FC<RouteComponentProps> = ({ history, location }) => {
  const redirectUrl = qs.parse(location.search.slice(1)).redirectUrl as string;

  useEffect(
    () => {
      setTimeout(() => {
        if (redirectUrl) {
          history.push(redirectUrl);
        } else {
          history.push(EXERCISE_RESERVATION);
        }
      }, 5000);
    }, // eslint-disable-next-line
    []
  );

  return (
    <Box style={styleDiv}>
      <Grid container justify={"center"}>
        <Alert variant="outlined" severity="success">
          Transakcja przebiegła pomyślnie
        </Alert>
      </Grid>
    </Box>
  );
};

export default FinalizeSuccess;
